import gql from 'graphql-tag';

import AppSyncConfig from '../aws-exports';
import { readToken } from '../../helpers/localStorage';

const GET_S3_PRE_SIGNED_URL_QUERY = `
  query GetS3PreSignedUrl($fileName: String!, $fileExtension: String!, $mimeType: String!) {
    getS3PreSignedUrl(FileName: $fileName, FileExtension: $fileExtension, MimeType: $mimeType)
  }
`;

export const GetS3PreSignedUrlQuery = gql`
  ${GET_S3_PRE_SIGNED_URL_QUERY}
`;

const fetchPreSignedUrlDirectly = async (fileName, fileExtension, mimeType) => {
  const response = await fetch(AppSyncConfig.awsAppsyncGraphqlEndpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      authorization: readToken() || null,
    },
    body: JSON.stringify({
      query: GET_S3_PRE_SIGNED_URL_QUERY,
      variables: {
        fileName,
        fileExtension,
        mimeType,
      },
    }),
  });

  const json = await response.json();
  if (!response.ok || json?.errors?.length) {
    const message = json?.errors?.[0]?.message || `Request failed with status ${response.status}`;
    throw new Error(message);
  }

  return json;
};

/**
 *
 * @param {Client} graphClient graphql client
 * @param {String} fileName string
 * @param {String} fileExtension string
 * @param {String} mimeType string
 * @returns Presigned S3 url
 */
export const getS3PreSignedUrl = async (graphClient, fileName, fileExtension, mimeType) => {
  const data = await graphClient.query({
    query: GetS3PreSignedUrlQuery,
    variables: {
      fileName,
      fileExtension,
      mimeType,
    },
    fetchPolicy: 'network-only', // User should be online
  });
  return data;
};

/**
 *
 * @param {Client} graphClient graphql client
 * @param {String} fileName string
 * @param {String} fileExtension string
 * @param {String} mimeType string
 * @returns Presigned S3 url
 */
export const getS3PreSignedUrlNoCache = async (graphClient, fileName, fileExtension, mimeType) => {
  return fetchPreSignedUrlDirectly(fileName, fileExtension, mimeType);
};
